import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/collection-area',
  component: Layout,
  redirect: '/collection-area',
  meta: {
    title: 'Collection area setting',
    root: true,
    auth: AUTH_KEYS.COLLECTION_AREA,
    isHide: true,
    notClickable: true
  },
  children: [
    {
      path: '/area-price-setting',
      name: 'CollectionAreaSetting',
      component: () => import('@/views/CollectionAreaSetting/Index.vue'),
      meta: {
        noBreadcrumb: true,
        title: 'collection_area',
        isHide: true,
        auth: AUTH_KEYS.COLLECTION_AREA,
        notClickable: true
      }
    }
  ]
};
